import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        addContent(ctx, queryParams) {
             return new Promise((resolve, reject) => {
                axios
                    .post('/packages/v1/contents/addContent', queryParams)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        UpdateOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams.items);

            return new Promise((resolve, reject) => {
              axios
                .post('/packages/v1/contents/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        deleteContent(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                  .delete(`/packages/v1/contents/delete/${id}`)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }
    }
}